import React, { useState } from "react";
import { Card, Row, Col, Button, Form, InputGroup, Accordion, Badge, Alert, Modal } from "react-bootstrap";
import Footer from "../layouts/Footer";

export default function AideSupport() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [showContactModal, setShowContactModal] = useState(false);
  const [contactForm, setContactForm] = useState({
    sujet: '',
    categorie: 'technique',
    description: '',
    urgence: 'normal'
  });

  // Catégories d'aide
  const categories = [
    { id: 'general', nom: 'Général', icon: 'bi-info-circle', color: 'primary' },
    { id: 'compte', nom: 'Compte & Facturation', icon: 'bi-person', color: 'success' },
    { id: 'sms', nom: 'Envoi de SMS', icon: 'bi-chat-dots', color: 'info' },
    { id: 'contacts', nom: 'Gestion des contacts', icon: 'bi-people', color: 'warning' },
    { id: 'campagnes', nom: 'Campagnes', icon: 'bi-megaphone', color: 'danger' },
    { id: 'api', nom: 'API & Intégration', icon: 'bi-code-slash', color: 'secondary' },
    { id: 'technique', nom: 'Problèmes techniques', icon: 'bi-tools', color: 'dark' }
  ];

  // Articles FAQ
  const faqArticles = [
    {
      id: 1,
      question: "Comment créer et envoyer ma première campagne SMS ?",
      reponse: "Pour créer votre première campagne SMS :\n\n1. Allez dans la section 'Campagnes SMS'\n2. Cliquez sur 'Nouvelle campagne'\n3. Sélectionnez vos destinataires (contacts ou groupe)\n4. Rédigez votre message en utilisant les variables disponibles\n5. Choisissez la date et l'heure d'envoi\n6. Validez et suivez l'avancement en temps réel",
      categorie: 'campagnes',
      popularite: 95,
      tags: ['campagne', 'premiers pas', 'envoi']
    },
    {
      id: 2,
      question: "Quelles sont les limites d'envoi de SMS ?",
      reponse: "Les limites dépendent de votre forfait :\n\n• Starter : 1 000 SMS/jour\n• Business : 10 000 SMS/jour\n• Enterprise : Illimité\n\nLes envois sont également limités à :\n• 160 caractères par SMS (concatenation automatique au-delà)\n• 10 SMS maximum par message (1 600 caractères)\n• Pas de spam - respect des règles anti-spam",
      categorie: 'sms',
      popularite: 88,
      tags: ['limites', 'forfaits', 'caractères']
    },
    {
      id: 3,
      question: "Comment importer mes contacts en masse ?",
      reponse: "Plusieurs méthodes d'import sont disponibles :\n\n1. Import CSV : Préparez un fichier avec colonnes Nom, Prénom, Téléphone\n2. Import Excel : Même format que CSV\n3. API : Utilisez notre API pour synchroniser automatiquement\n4. Saisie manuelle : Pour de petits volumes\n\nLe système détecte automatiquement les doublons et nettoie les numéros invalides.",
      categorie: 'contacts',
      popularite: 92,
      tags: ['import', 'contacts', 'csv', 'excel']
    },
    {
      id: 4,
      question: "Comment fonctionne l'API ?",
      reponse: "Notre API REST permet d'intégrer l'envoi de SMS dans vos applications :\n\n• Endpoint : https://api.votredomaine.com/v1/sms/send\n• Méthode : POST\n• Authentification : Clé API dans le header\n• Format : JSON\n\nExemple de requête :\n```json\n{\n  \"to\": \"+241XXXXXXXX\",\n  \"message\": \"Votre message\",\n  \"sender\": \"VotreSenderID\"\n}\n```",
      categorie: 'api',
      popularite: 76,
      tags: ['api', 'integration', 'documentation']
    },
    {
      id: 5,
      question: "Mon solde n'est pas mis à jour, que faire ?",
      reponse: "Si votre solde ne se met pas à jour :\n\n1. Vérifiez l'historique des transactions\n2. Consultez les reçus de paiement\n3. Vérifiez le statut de vos dernières recharges\n4. Contactez le support si le problème persiste\n\nLes mises à jour de solde sont généralement instantanées. En cas de retard, un rechargement manuel peut être nécessaire.",
      categorie: 'compte',
      popularite: 82,
      tags: ['solde', 'paiement', 'recharge']
    },
    {
      id: 6,
      question: "Pourquoi mes SMS ne sont-ils pas délivrés ?",
      reponse: "Plusieurs raisons peuvent empêcher la délivrabilité :\n\n• Numéro invalide ou format incorrect\n• Solde insuffisant\n• Contenu bloqué (spam, mots interdits)\n• Problème opérateur temporaire\n• Blacklist du numéro\n\nConsultez les logs de délivrabilité pour identifier la cause exacte.",
      categorie: 'technique',
      popularite: 85,
      tags: ['delivrabilité', 'echec', 'problemes']
    },
    {
      id: 7,
      question: "Comment créer des modèles de messages ?",
      reponse: "Pour créer des modèles réutilisables :\n\n1. Allez dans 'Gestion des modèles'\n2. Cliquez sur 'Nouveau modèle'\n3. Donnez un nom et sélectionnez une catégorie\n4. Rédigez votre template avec variables {nom}, {prenom}, etc.\n5. Sauvegardez et utilisez-le dans vos campagnes\n\nLes templates accélèrent la création de campagnes répétitives.",
      categorie: 'sms',
      popularite: 79,
      tags: ['templates', 'modeles', 'messages']
    },
    {
      id: 8,
      question: "Qu'est-ce qu'un Sender ID et comment l'obtenir ?",
      reponse: "Le Sender ID est l'identifiant d'expéditeur affiché sur les téléphones :\n\n• Alphanumérique : 3-11 caractères (ex: VOTREENTREPRISE)\n• Numérique : Numéro dédié (ex: 241XXXXXXXX)\n\nPour obtenir un Sender ID :\n1. Soumettez une demande depuis 'Gestion des Sender ID'\n2. Attendez l'approbation (24-48h)\n3. Utilisez-le dans vos campagnes\n\nL'approbation dépend des opérateurs et de la conformité.",
      categorie: 'general',
      popularite: 91,
      tags: ['senderid', 'expediteur', 'approbation']
    },
    {
      id: 9,
      question: "Comment configurer les webhooks ?",
      reponse: "Les webhooks permettent de recevoir des notifications :\n\n1. Allez dans 'Gestion des Webhooks'\n2. Créez un nouveau webhook\n3. Configurez l'URL de callback\n4. Sélectionnez les événements à écouter\n5. Testez la configuration\n\nÉvénements disponibles : SMS envoyé, délivré, échoué, contact créé, etc.",
      categorie: 'api',
      popularite: 73,
      tags: ['webhooks', 'notifications', 'api']
    },
    {
      id: 10,
      question: "Puis-je envoyer des SMS à l'international ?",
      reponse: "Oui, l'envoi international est disponible :\n\n• Formater les numéros avec l'indicatif (+33, +241, etc.)\n• Tarifs variables selon les pays\n• Vérifier la couverture par pays\n• Respecter les réglementations locales\n\nConsultez la grille tarifaire pour les détails par destination.",
      categorie: 'sms',
      popularite: 68,
      tags: ['international', 'tarifs', 'pays']
    }
  ];

  // Tutoriels
  const tutoriels = [
    {
      id: 1,
      titre: "Premiers pas avec la plateforme",
      duree: "5 min",
      niveau: "Débutant",
      categorie: "general",
      video: true,
      steps: 4
    },
    {
      id: 2,
      titre: "Créer et gérer des campagnes efficaces",
      duree: "12 min",
      niveau: "Intermédiaire",
      categorie: "campagnes",
      video: true,
      steps: 7
    },
    {
      id: 3,
      titre: "Automatiser avec l'API",
      duree: "18 min",
      niveau: "Avancé",
      categorie: "api",
      video: true,
      steps: 9
    },
    {
      id: 4,
      titre: "Optimiser la délivrabilité des SMS",
      duree: "8 min",
      niveau: "Intermédiaire",
      categorie: "sms",
      video: false,
      steps: 5
    },
    {
      id: 5,
      titre: "Gestion avancée des contacts",
      duree: "10 min",
      niveau: "Intermédiaire",
      categorie: "contacts",
      video: true,
      steps: 6
    }
  ];

  // Filtrage des articles FAQ
  const filteredFaq = faqArticles.filter(article => {
    const matchesSearch = article.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         article.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));
    const matchesCategory = selectedCategory === 'all' || article.categorie === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  // Filtrage des tutoriels
  const filteredTutoriels = tutoriels.filter(tutoriel => {
    return selectedCategory === 'all' || tutoriel.categorie === selectedCategory;
  });

  // Gestion du formulaire de contact
  const handleContactSubmit = (e) => {
    e.preventDefault();
    // Simulation d'envoi
    alert("Votre demande a été envoyée. Notre équipe vous répondra dans les plus brefs délais.");
    setContactForm({
      sujet: '',
      categorie: 'technique',
      description: '',
      urgence: 'normal'
    });
    setShowContactModal(false);
  };

  // Obtenir le nom de la catégorie
  const getCategoryName = (categoryId) => {
    const category = categories.find(cat => cat.id === categoryId);
    return category ? category.nom : 'Général';
  };

  return (
    <div className="main main-app p-3 p-lg-4">
      <div className="container-fluid">
        {/* En-tête */}
        <Row className="mb-4">
          <Col md={12}>
            <div className="text-center mb-4">
              <h1 className="fw-bold text-primary mb-3">
                <i className="bi bi-question-circle me-3"></i>
                Centre d'Aide & Support
              </h1>
              <p className="lead text-muted">
                Trouvez rapidement des réponses à vos questions ou contactez notre équipe support
              </p>
            </div>

            {/* Barre de recherche */}
            <Card className="shadow-sm border-0 mb-4">
              <Card.Body className="p-4">
                <Row className="align-items-center">
                  <Col md={8}>
                    <InputGroup size="lg">
                      <InputGroup.Text className="bg-light border-0">
                        <i className="bi bi-search text-muted"></i>
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        placeholder="Rechercher dans l'aide (ex: 'campagne', 'API', 'solde'...)"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="border-0 bg-light"
                      />
                    </InputGroup>
                  </Col>
                  <Col md={4} className="text-end">
                    <Button 
                      variant="primary" 
                      size="lg"
                      onClick={() => setShowContactModal(true)}
                    >
                      <i className="bi bi-headset me-2"></i>
                      Contacter le support
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row>
          {/* Catégories */}
          <Col lg={3} className="mb-4">
            <Card className="shadow-sm border-0 h-100">
              <Card.Header className="bg-light">
                <h5 className="mb-0">
                  <i className="bi bi-folder me-2"></i>
                  Catégories
                </h5>
              </Card.Header>
              <Card.Body className="p-0">
                <div className="list-group list-group-flush">
                  <button
                    className={`list-group-item list-group-item-action border-0 ${selectedCategory === 'all' ? 'active' : ''}`}
                    onClick={() => setSelectedCategory('all')}
                  >
                    <i className="bi bi-grid me-2"></i>
                    Toutes les catégories
                    <Badge bg={selectedCategory === 'all' ? 'light' : 'primary'} text={selectedCategory === 'all' ? 'dark' : 'light'} className="ms-2">
                      {faqArticles.length}
                    </Badge>
                  </button>
                  {categories.map((category) => (
                    <button
                      key={category.id}
                      className={`list-group-item list-group-item-action border-0 ${selectedCategory === category.id ? 'active' : ''}`}
                      onClick={() => setSelectedCategory(category.id)}
                    >
                      <i className={`${category.icon} me-2 text-${category.color}`}></i>
                      {category.nom}
                      <Badge 
                        bg={selectedCategory === category.id ? 'light' : category.color} 
                        text={selectedCategory === category.id ? 'dark' : 'light'} 
                        className="ms-2"
                      >
                        {faqArticles.filter(article => article.categorie === category.id).length}
                      </Badge>
                    </button>
                  ))}
                </div>
              </Card.Body>
            </Card>

            {/* Statistiques support */}
            {/* <Card className="shadow-sm border-0 mt-4">
              <Card.Header className="bg-light">
                <h5 className="mb-0">
                  <i className="bi bi-graph-up me-2"></i>
                  Support
                </h5>
              </Card.Header>
              <Card.Body>
                <div className="text-center">
                  <div className="row">
                    <div className="col-6 mb-3">
                      <i className="bi bi-clock text-warning fs-1"></i>
                      <div className="small text-muted">Temps moyen</div>
                      <div className="fw-bold">2h 15min</div>
                    </div>
                    <div className="col-6 mb-3">
                      <i className="bi bi-check-circle text-success fs-1"></i>
                      <div className="small text-muted">Taux de résolution</div>
                      <div className="fw-bold">98%</div>
                    </div>
                  </div>
                  <Alert variant="info" className="small">
                    <i className="bi bi-info-circle me-2"></i>
                    Support disponible 7j/7 de 8h à 20h
                  </Alert>
                </div>
              </Card.Body>
            </Card> */}
          </Col>

          {/* Contenu principal */}
          <Col lg={9}>
            {/* Résultats de recherche */}
            {searchTerm && (
              <Card className="shadow-sm border-0 mb-4">
                <Card.Header className="bg-light">
                  <h5 className="mb-0">
                    <i className="bi bi-search me-2"></i>
                    Résultats pour "{searchTerm}"
                    <Badge bg="primary" className="ms-2">
                      {filteredFaq.length} résultat(s)
                    </Badge>
                  </h5>
                </Card.Header>
              </Card>
            )}

            {/* Articles populaires */}
            <Card className="shadow-sm border-0 mb-4">
              <Card.Header className="bg-light d-flex justify-content-between align-items-center">
                <h5 className="mb-0">
                  <i className="bi bi-star me-2"></i>
                  Articles populaires
                </h5>
                <Badge bg="warning">
                  <i className="bi bi-fire me-1"></i>
                  Les plus consultés
                </Badge>
              </Card.Header>
              <Card.Body>
                <Accordion flush>
                  {filteredFaq
                    .sort((a, b) => b.popularite - a.popularite)
                    .slice(0, 5)
                    .map((article, index) => (
                    <Accordion.Item key={article.id} eventKey={index.toString()}>
                      <Accordion.Header>
                        <div className="d-flex align-items-center w-100">
                          <div className="flex-grow-1">
                            {article.question}
                          </div>
                          <div className="d-flex align-items-center ms-3">
                            <Badge bg="light" text="dark" className="me-2">
                              {getCategoryName(article.categorie)}
                            </Badge>
                            <Badge bg="success" className="me-2">
                              {article.popularite}%
                            </Badge>
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="whitespace-pre-line">{article.reponse}</div>
                        <div className="mt-3">
                          <strong>Tags :</strong>
                          {article.tags.map((tag, tagIndex) => (
                            <Badge key={tagIndex} bg="outline-primary" text="dark" className="ms-2">
                              {tag}
                            </Badge>
                          ))}
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </Card.Body>
            </Card>

            {/* Tutoriels et guides */}
            <Card className="shadow-sm border-0 mb-4">
              <Card.Header className="bg-light">
                <h5 className="mb-0">
                  <i className="bi bi-play-circle me-2"></i>
                  Tutoriels & Guides
                </h5>
              </Card.Header>
              <Card.Body>
                <Row>
                  {filteredTutoriels.map((tutoriel) => (
                    <Col key={tutoriel.id} md={6} className="mb-3">
                      <Card className="h-100 border">
                        <Card.Body>
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <Badge bg={tutoriel.niveau === 'Débutant' ? 'success' : tutoriel.niveau === 'Intermédiaire' ? 'warning' : 'danger'}>
                              {tutoriel.niveau}
                            </Badge>
                            <div className="d-flex align-items-center">
                              {tutoriel.video && (
                                <i className="bi bi-camera-video text-primary me-2"></i>
                              )}
                              <small className="text-muted">{tutoriel.duree}</small>
                            </div>
                          </div>
                          <h6 className="fw-bold">{tutoriel.titre}</h6>
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <Badge bg="light" text="dark">
                              {tutoriel.steps} étapes
                            </Badge>
                            <Button variant="outline-primary" size="sm">
                              Commencer
                              <i className="bi bi-arrow-right ms-1"></i>
                            </Button>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Card.Body>
            </Card>

            {/* Toute la FAQ */}
            <Card className="shadow-sm border-0">
              <Card.Header className="bg-light">
                <h5 className="mb-0">
                  <i className="bi bi-journal-text me-2"></i>
                  Foire Aux Questions Complète
                </h5>
              </Card.Header>
              <Card.Body>
                <Accordion flush>
                  {filteredFaq.map((article, index) => (
                    <Accordion.Item key={article.id} eventKey={index.toString()}>
                      <Accordion.Header>
                        <div className="d-flex align-items-center w-100">
                          <div className="flex-grow-1">
                            {article.question}
                          </div>
                          <Badge bg="light" text="dark" className="me-2">
                            {getCategoryName(article.categorie)}
                          </Badge>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="whitespace-pre-line">{article.reponse}</div>
                        <div className="mt-3">
                          <strong>Tags :</strong>
                          {article.tags.map((tag, tagIndex) => (
                            <Badge key={tagIndex} bg="outline-primary" text="dark" className="ms-2">
                              {tag}
                            </Badge>
                          ))}
                        </div>
                        <div className="mt-3 text-end">
                          <small className="text-muted">
                            <i className="bi bi-hand-thumbs-up me-1"></i>
                            {article.popularite}% des utilisateurs ont trouvé cet article utile
                          </small>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>

                {filteredFaq.length === 0 && (
                  <div className="text-center py-5">
                    <i className="bi bi-search display-4 text-muted"></i>
                    <h5 className="mt-3 text-muted">Aucun article trouvé</h5>
                    <p className="text-muted">
                      Essayez d'autres termes de recherche ou <a href="#contact" onClick={() => setShowContactModal(true)}>contactez notre support</a>.
                    </p>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Modal de contact support */}
      <Modal show={showContactModal} onHide={() => setShowContactModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="bi bi-headset me-2"></i>
            Contacter le support
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleContactSubmit}>
          <Modal.Body>
            <Alert variant="info">
              <i className="bi bi-info-circle me-2"></i>
              Notre équipe support vous répond généralement dans les 2 heures suivant votre demande.
            </Alert>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Sujet *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Décrivez brièvement votre problème"
                    value={contactForm.sujet}
                    onChange={(e) => setContactForm({...contactForm, sujet: e.target.value})}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Catégorie *</Form.Label>
                  <Form.Select
                    value={contactForm.categorie}
                    onChange={(e) => setContactForm({...contactForm, categorie: e.target.value})}
                  >
                    <option value="technique">Problème technique</option>
                    <option value="compte">Compte & Facturation</option>
                    <option value="fonctionnalite">Demande de fonctionnalité</option>
                    <option value="autre">Autre</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Niveau d'urgence</Form.Label>
              <div>
                <Form.Check
                  inline
                  type="radio"
                  name="urgence"
                  label="Normal"
                  value="normal"
                  checked={contactForm.urgence === 'normal'}
                  onChange={(e) => setContactForm({...contactForm, urgence: e.target.value})}
                />
                <Form.Check
                  inline
                  type="radio"
                  name="urgence"
                  label="Élevé"
                  value="eleve"
                  checked={contactForm.urgence === 'eleve'}
                  onChange={(e) => setContactForm({...contactForm, urgence: e.target.value})}
                />
                <Form.Check
                  inline
                  type="radio"
                  name="urgence"
                  label="Critique"
                  value="critique"
                  checked={contactForm.urgence === 'critique'}
                  onChange={(e) => setContactForm({...contactForm, urgence: e.target.value})}
                />
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Description détaillée *</Form.Label>
              <Form.Control
                as="textarea"
                rows={6}
                placeholder="Décrivez votre problème ou question en détail. Incluez les étapes pour reproduire le problème si applicable."
                value={contactForm.description}
                onChange={(e) => setContactForm({...contactForm, description: e.target.value})}
                required
              />
            </Form.Group>

            <Alert variant="warning" className="small">
              <i className="bi bi-lightbulb me-2"></i>
              <strong>Conseil :</strong> Incluez des captures d'écran, numéros de téléphone concernés, et dates/heures précises pour nous aider à résoudre votre problème plus rapidement.
            </Alert>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowContactModal(false)}>
              Annuler
            </Button>
            <Button 
              variant="primary" 
              type="submit"
              disabled={!contactForm.sujet || !contactForm.description}
            >
              <i className="bi bi-send me-2"></i>
              Envoyer la demande
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <style>{`
        .whitespace-pre-line {
          white-space: pre-line;
        }
        .list-group-item.active {
          background-color: #0d6efd;
          border-color: #0d6efd;
        }
        .accordion-button:not(.collapsed) {
          background-color: #f8f9fa;
          color: #000;
        }
      `}</style>
      <Footer />
    </div>
  );
}